import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) return (
      <div style={{padding:'2rem',fontFamily:'monospace',background:'#1e1e1e',color:'#f87171',minHeight:'100vh'}}>
        <h2>SpineBase Error</h2>
        <pre style={{whiteSpace:'pre-wrap',marginTop:'1rem'}}>{this.state.error.toString()}</pre>
        <button onClick={()=>{localStorage.clear();window.location.reload()}} style={{marginTop:'1rem',padding:'0.5rem 1rem',background:'#2563eb',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer'}}>Clear Cache & Reload</button>
      </div>
    );
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ErrorBoundary><App /></ErrorBoundary>);
